import { useRbTexts } from 'remote-state/applicationHooks';

export default function useTexts() {
  const texts = useRbTexts();
  const componentTexts = {
    modal: {
      title: texts?.['spaces.reloadPageModal.title'] || 'New version update required',
      description: texts?.['spaces.reloadPageModal.description'] || 'We\'ll need to reload this page to update your environment',
      btnOkText: texts?.['spaces.reloadPageModal.OkText'] || 'Refresh',
    },
    updatedPermissions: {
      title: texts?.['spaces.updatedPermissions.title'] || 'System Permissions updated',
      description: texts?.['spaces.updatedPermissions.description'] || 'Please refresh the page to access the service desk with your updated permissions.',
      refreshPageButton: texts?.['spaces.updatedPermissions.refreshPageButton'] || 'Refresh page',
    }
  };

  return componentTexts;
}
